import { GETCHECKAUTH } from "@/graphql/AccountMutations.js";
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import store from "@/store/index.js";

export default {
  requireToken: (target) => async (from, to, next) => {
    const token = localStorage.getItem("token");

    try {
      // 토큰이 없는 경우
      if (!token) {
        if (
          target == "login" ||
          target == "forgot" ||
          target == "findId" ||
          target == "findPw"
        ) {
          return next();
        } else {
          alert("Please log in first");
          return next("/Login");
        }
      } else {
        if (
          target == "login" ||
          target == "forgot" ||
          target == "findId" ||
          target == "findPw"
        ) {
          alert("You are already logged in.");
          return next("/Orders");
        }
      }

      // 유저 정보 저장
      try {
        const result = await runGqlMutation(GETCHECKAUTH, { token: token });
        if (
          result.message === "GraphQL error: Connection err." ||
          !result.getCheckAuth
        ) {
          // 잘못된 접근
          alert("Wrong approach");
          localStorage.removeItem("token");
          next("/login");
        }
        await store.commit("account/setUser", result.getCheckAuth);

        // 권한 확인 후 페이지 이동 처리
        if (target === "master") {
          if (result.getCheckAuth.Permission === 1) {
            // master
            store.state.common.menu.dashboard = true;
            return next();
          } else {
            // admin
            store.state.common.menu.dashboard = false;
            alert("No page permissions");
            return next("/Orders");
          }
        } else if (target === "admin") {
          if (result.getCheckAuth.Permission === 1) {
            // master
            store.state.common.menu.dashboard = true;
            return next();
          } else {
            // admin
            store.state.common.menu.dashboard = false;
            return next();
          }
        }
      } catch (error) {
        console.log(error.message);
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * calculate date
   * @param date String ex) 2022-04-12
   * @param days number
   * @returns days에 의해 증감한 날짜 String ex) 2022-04-12
   * @author 송은석 2022-04-12
   */
  calculateDate: (date, days) => {
    const tempDate = new Date(date);
    tempDate.setUTCDate(tempDate.getUTCDate() + days);

    return tempDate.toISOString().substring(0, 10);
  },

  /**
   * String timestamp to String date
   * @param date String ex) 1607110465663
   * @returns 형식에 맞게 변환된 time String ex) 2/22/2022 03:45:55
   * @author 송은석 2022-04-12
   */
  typeDate: (date) => {
    const formedDate = new Date(parseInt(date));

    return (
      formedDate.getFullYear() +
      "/" +
      String(formedDate.getMonth() + 1).padStart(2, "0") +
      "/" +
      String(formedDate.getDate()).padStart(2, "0") +
      " " +
      String(formedDate.getHours()).padStart(2, "0") +
      ":" +
      String(formedDate.getMinutes()).padStart(2, "0") +
      ":" +
      String(formedDate.getSeconds()).padStart(2, "0")
    );
  },

  /**
   * Number money to  money String
   * @param Number money ex) 1607110465663
   * @returns 형식에 맞게 변환된 money String ex) 1,234,567.001
   * @author 송은석 2022-04-12
   */
  typeMoney: (money) => {
    if (typeof money !== "number") {
      return " ";
    } else if (0 <= money && money < 1000) {
      return money;
    } else if (money < 0 || 1000 <= money) {
      let ifMinus = false;

      if (money < 0) {
        ifMinus = true;
        money = Math.abs(money);
      }

      money += "";
      const sep = money.split(".");
      let result = "";

      for (let i = 1; i <= sep[0].length; i++) {
        result = sep[0][sep[0].length - i] + result;
        if (i % 3 === 0 && i !== sep[0].length) {
          result = "," + result;
        }
      }

      if (sep[1] !== undefined) result += "." + sep[1];
      if (ifMinus) result = "-" + result;

      return result;
    }
  },

  /**
   * Number money to String money demical rounding
   * @param Number ex) 123.123456789
   * @returns String 소수점 두자리 까지 변환, nan이면 처리.  ex) 123.12
   * @author 송은석 2022-04-20
   */
  roundToTwo: (num) => {
    //num nan 처리해주기
    if (isNaN(num)) {
      return "";
    }
    return +(Math.round(num + "e+2") + "e-2");
  },
};
